/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Header, Footer } from '../../../components/index'
import { WebApi } from '../../../api/web'
import { UploadsUrl } from '../../../services/url'
import { Row, Col } from 'react-bootstrap'
const Product = () => {
  const [products, setProducts] = useState(null)
  const [trackingCode, setTrackingCode] = useState(null)
  const [error, setError] = useState(false)
  const { id } = useParams()

  useEffect(() => {
    OrderSingle()
  }, [])

  const OrderSingle = async () => {
    await WebApi.orderSingle(id)
      .then((res) => {
        setTrackingCode(res.data.data.orderSingle.trackingCode)
        setProducts(res.data.data.orderSingle.products)
        if (res.data.data.orderSingle.statusPayment == 1) {
          setError(true)
        }
      })
      .catch((err) => {
        setError(true)
      })
  }
  return (
    <>
      <Header title={`کد پیگیری ${trackingCode ? trackingCode : ''}`} />
      {error ? (
        <div className='callback'>
          <h4 className='text-center' style={{ color: '#dc3545' }}>
            تراکنش شما ناموفق است
          </h4>
          <div className='body-callback'>
            <div className='data-callback'>
              <p className='text-center'>
                درصورت کسر از حساب شما در عرض 72 ساعت آینده به حسابتان واریز می
                شود
              </p>

              <div className='text-center mt-5'>
                <a href='/product-list' className='btn btn-danger'>
                  بازگشت به سایت
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='container'>
          <div className='template-pages'>
            {products &&
              products.map((product) => (
                <div className='book-cover wow fadeInUp'>
                  <Row className='align-items-center'>
                    <Col
                      xs={4}
                      sm={3}
                      className='d-flex justify-content-center'
                    >
                      <img src={product.product.image} alt='book' />
                    </Col>
                    <Col xs={8} sm={9} className='pr-0'>
                      <div className='detail'>
                        <a
                          href={`/product/${product.product._id}`}
                          target='_blank'
                        >
                          <h5>{product.product.title}</h5>
                        </a>
                        <span>ddddddddddddddddddddddd</span>
                        {product.product.isDownloadable ? (
                          <a
                            href={`${UploadsUrl}/${product.product.pdf}`}
                            target='_blank'
                          >
                            دانلود
                          </a>
                        ) : (
                          <span>وضعیت : ارسالی</span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
          </div>
        </div>
      )}
      <Footer />
    </>
  )
}
export default Product
